declare var process : {
    env: {
        NODE_ENV: string,
        VUE_APP_API_BASE_URL: string,
        VUE_APP_STAGING_AUTHORITY: string,
        VUE_APP_REDIRECT_URI: string,
        VUE_APP_POST_LOGOUT_REDIREC_URI: string,
        VUE_APP_CLIENT_ID: string,
        VUE_APP_ADMIN_ROLE: string,
        VUE_APP_ROUTER_BASE: string

    }
}

export const API_DEV_URL = process.env.VUE_APP_API_BASE_URL;
export const STAGING_AUTHORITY = process.env.VUE_APP_STAGING_AUTHORITY;
export const REDIRECT_URI = process.env.VUE_APP_REDIRECT_URI;
export const POST_LOGOUT_REDIREC_URI = process.env.VUE_APP_POST_LOGOUT_REDIREC_URI;
export const CLIENT_ID=process.env.VUE_APP_CLIENT_ID;
export const ADMIN_ROLE=process.env.VUE_APP_ADMIN_ROLE;
export const ROUTER_BASE=process.env.VUE_APP_ROUTER_BASE;
// tslint:disable-next-line:max-line-length
export const DUMMY_TOKEN = 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJFSHBMRERUWjdQR1RXazBGUE53eU9YNG5feHFScXBBWjAxNC1xSXB2WXlRIn0.eyJqdGkiOiI2MDVkMDMyZS0yNDllLTQyMTgtYjgxOC02ZDc5MTVjZjJmNjYiLCJleHAiOjE1MzMzMTAyOTYsIm5iZiI6MCwiaWF0IjoxNTMzMzA5OTk2LCJpc3MiOiJodHRwczovL2lkbS5jaW5lbWFsYWNvbXBhZ25pYS5pdC9hdXRoL3JlYWxtcy9jbGMiLCJhdWQiOiJhZG1pbi1jbGkiLCJzdWIiOiIzZTVmM2Y1OC02ZjJiLTQ4MGYtYWRhMS05ZGZhNTFlZmY1OGYiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJhZG1pbi1jbGkiLCJhdXRoX3RpbWUiOjAsInNlc3Npb25fc3RhdGUiOiJkYjQxZGY1OS00MzY1LTQ1ODAtYWUyOS1hY2Y1NmY0ZTMxNmUiLCJhY3IiOiIxIiwiYWxsb3dlZC1vcmlnaW5zIjpbXSwicmVzb3VyY2VfYWNjZXNzIjp7fSwibmFtZSI6Ik1hdXJvIEJlcm5hcmRpIiwicHJlZmVycmVkX3VzZXJuYW1lIjoibWF1cm8uYmVybmFyZGlAcGhvb3BzLml0IiwiZ2l2ZW5fbmFtZSI6Ik1hdXJvIiwiZmFtaWx5X25hbWUiOiJCZXJuYXJkaSIsImVtYWlsIjoibWF1cm8uYmVybmFyZGlAcGhvb3BzLml0In0.XwE3lbvlaE9OpldjO7q5na71J4UzaWHFDib2LXs9O9q3u_zzJ--XSSzC7yOrsvqJ7nZ5OZ9aEXCkkqBkGlLtGXXBUnsSuRY6HYjl12mmsWoF68QM_cTNSKHelavKJFh3xQr-zBMNAxNgfHXD7r6zwV0irZ2CDOC6cki-BFCAmHAhIIvd3SaREoFUtvmo52WMq5YfhsnSLejMIud2wJswDioNKQMl08LvbC6vSXL4ZhkgvCusq64FQwuFpRkteqsC7v-62hLnW7W8JXKqnQmZqHTfnaBs09FofzB0gk2QFqATEr_8w3CgqmZjaLu13b1bWFrtocpPvadoBFtNrPJ1OA';

// PROD
export const API_BASE_URL = 'https://app.cinemalacompagnia.it/ubu/api/v1';
